import React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { postSignup } from '../api/loginApi';

export function Signup() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const onSubmit = (e) => {
    if (username.length > 0 && password.length > 0) {
      postSignup(username, password)
        .then((data) => {
          if (data.success) {
            navigate('/login');
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          setError(true);
        });
    } else {
      setError(true);
    }
    e.preventDefault();
  };

  return (
    <>
      <h2 className="column-flex align-center">ALO INC - Signup Page</h2>
      <div className="column-flex align-center">
        <form>
          <div className="column-flex align-center">
            <label>
              Username:
              <input
                onInput={(e) => {
                  setUsername(e.target.value);
                }}
                type="text"
                name="username"
              />
            </label>
            <br />
            <label>
              Password:
              <input
                onInput={(e) => {
                  setPassword(e.target.value);
                }}
                type="password"
                name="password"
              />
            </label>
            <br />
            <div className="row-flex align-center">
              <button type="submit" onClick={onSubmit}>
                Create account
              </button>
              <button type="submit" onClick={() => navigate('/login')}>
                Go to login
              </button>
            </div>
          </div>
        </form>
      </div>
      <div>
        {error && (
          <p style={{ color: 'red' }} className="column-flex align-center">
            You are a retard
          </p>
        )}
      </div>
    </>
  );
}
